import PropTypes from "prop-types";
import SeccionWrapper from "../SeccionWrapper";
import StepFasesServicios from "../../FormularioPropuestaV2/steps/StepFasesServicios";

const SeccionFasesServicios = ({
  formik,
  faltantes,
  razonesSeleccionIA,
  limpiarRazonSeleccionIA,
  resetRazonesSeleccionIA,
  swapRazonesSeleccionIA,
}) => (
  <SeccionWrapper
    id="seccion-servicios"
    numero={5}
    titulo="Fases y servicios"
    faltantes={faltantes}
  >
    <StepFasesServicios
      formik={formik}
      razonesSeleccionIA={razonesSeleccionIA}
      limpiarRazonSeleccionIA={limpiarRazonSeleccionIA}
      resetRazonesSeleccionIA={resetRazonesSeleccionIA}
      swapRazonesSeleccionIA={swapRazonesSeleccionIA}
    />
  </SeccionWrapper>
);

SeccionFasesServicios.propTypes = {
  formik: PropTypes.object.isRequired,
  faltantes: PropTypes.arrayOf(PropTypes.string),
  razonesSeleccionIA: PropTypes.object.isRequired,
  limpiarRazonSeleccionIA: PropTypes.func.isRequired,
  resetRazonesSeleccionIA: PropTypes.func.isRequired,
  swapRazonesSeleccionIA: PropTypes.func.isRequired,
};

export default SeccionFasesServicios;
